"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVendorMasterSchema = exports.createVendorMasterSchema = exports.vendorMasterShape = void 0;
const zod_1 = require("zod");
exports.vendorMasterShape = {
    vendorCode: zod_1.z.string().min(1).max(30).optional(),
    name: zod_1.z.string().min(1).max(255),
    gstin: zod_1.z.string().max(20).optional(),
    pan: zod_1.z.string().max(20).optional(),
    contactEmail: zod_1.z.string().email().optional(),
    contactPhone: zod_1.z.string().max(20).optional(),
    contactPhone2: zod_1.z.string().max(20).optional(),
    address: zod_1.z.string().optional(),
    paymentTermsDays: zod_1.z.number().int().nonnegative().optional(),
    tdsApplicable: zod_1.z.boolean().optional(),
    tdsSectionId: zod_1.z.string().uuid().optional(),
    tdsRatePercent: zod_1.z.number().min(0).max(100).optional(),
};
exports.createVendorMasterSchema = zod_1.z.object(exports.vendorMasterShape);
exports.updateVendorMasterSchema = zod_1.z.object({
    name: exports.vendorMasterShape.name.optional(),
    gstin: exports.vendorMasterShape.gstin,
    pan: exports.vendorMasterShape.pan,
    contactEmail: exports.vendorMasterShape.contactEmail,
    contactPhone: exports.vendorMasterShape.contactPhone,
    contactPhone2: exports.vendorMasterShape.contactPhone2,
    address: exports.vendorMasterShape.address,
    paymentTermsDays: exports.vendorMasterShape.paymentTermsDays,
    tdsApplicable: exports.vendorMasterShape.tdsApplicable,
    tdsSectionId: exports.vendorMasterShape.tdsSectionId,
    tdsRatePercent: exports.vendorMasterShape.tdsRatePercent,
});
//# sourceMappingURL=vendor-master.schema.js.map